import React from 'react';
import { Skeleton } from '../Skeleton';

export const GreetingLoadingPlaceholder: React.FC = () => <Skeleton height={50} className="u-mb" />;
